const moesDocumentsInitialState = {
  moesDocuments: {
    moesDocuments: {},
    moesDocumentsLoading: false,
    moesDocumentsError: {},
  },
};

export default moesDocumentsInitialState;
